import { render, staticRenderFns } from "./contentAudit.vue?vue&type=template&id=0bceadf0&scoped=true"
import script from "./contentAudit.vue?vue&type=script&lang=js"
export * from "./contentAudit.vue?vue&type=script&lang=js"
import style0 from "./contentAudit.vue?vue&type=style&index=0&id=0bceadf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bceadf0",
  null
  
)

export default component.exports